import { AbstractModel } from '@uzurv/core';
import { AmenityType } from './amenity-type';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';

@inheritSerialization(AbstractModel)
export class Amenity extends AbstractModel {
  @autoserialize
  name: string;

  @autoserialize
  code: string;

  @autoserialize
  description: string;

  @autoserializeAs(AmenityType)
  amenityType: AmenityType;

  @autoserialize
  active: boolean;
}
